import React from "react";

import ExamSection from "./ExamSection";
import NewsSection from "../news/NewsSection";
import FeatureSection from "./FeatureSection";
import BannerSection from "./BannerSection";
import CourseSection from "./CourseSection";
import ContactForm from "./ContactForm";
import "./index.css";

export default function Main() {
  return (
    <>
      <BannerSection />
      <FeatureSection />
      {/* <ExamSection /> */}
      <NewsSection />
      <CourseSection />
      <ContactForm />
    </>
  );
}
